import apiGetRequest from './api-get-request'
import getWithToken from './get-with-token'

/**
 * Public (shared link) request: the share token goes in a header, not the URL
 */
const getWithShareToken = (endpoint, shareToken, params) => {
  const queryString = new URLSearchParams(params).toString()
  const url = queryString ? `${endpoint}?${queryString}` : endpoint
  return apiGetRequest(url)({ headers: { 'x-share-token': shareToken } })
}

/**
 * Helper function to create API functions that support both authenticated and share-token-based access
 * @param {string} endpoint - The API endpoint path
 * @returns {Function} - API function that handles both auth token and shareToken parameter
 */
const apiWithOptionalCode = (endpoint) => {
  return ({ shareToken, ...params } = {}) => {
    // If shareToken parameter is provided, use public API without login token
    if (shareToken) {
      return getWithShareToken(endpoint, shareToken, params)
    }
    
    // Otherwise use authenticated API
    return getWithToken(endpoint)(params)
  }
}

/**
 * Helper for customer-specific endpoints
 * @param {string} path - The path after /customer/:id/
 * @returns {Function} - API function for customer endpoints
 */
const customerApiWithOptionalCode = (path) => {
  return (id, { shareToken, ...params } = {}) => {
    const endpoint = `/customer/${id}/${path}`
    
    // If shareToken parameter is provided, use public API without login token
    if (shareToken) {
      return getWithShareToken(endpoint, shareToken, params)
    }
    
    // Otherwise use authenticated API
    return getWithToken(endpoint)(params)
  }
}

export { apiWithOptionalCode, customerApiWithOptionalCode, getWithShareToken }
export default apiWithOptionalCode
